




import VueOptions from '@utils/VueOptions'
import AudienceCreativeEditWizard from '@ui/AudienceCreativeWizard/AudienceCreativeEditWizard'

settings =
  name: 'AudienceCreativeList'
  components: { AudienceCreativeEditWizard }

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'audience_creatives/:audienceCreativeId/edit'

  vue:
    computed:
      optionsForCreativeWizard: ->
        supplierId: @supplierId

      supplierId: -> @prime?.audience_creative?.supplier_id

export default VueOptions.vue settings
